import { render, staticRenderFns } from "./EditorBlockGroupObjects.vue?vue&type=template&id=b4821430&scoped=true"
import script from "./EditorBlockGroupObjects.vue?vue&type=script&lang=js"
export * from "./EditorBlockGroupObjects.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockGroupObjects.vue?vue&type=style&index=0&id=b4821430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4821430",
  null
  
)

export default component.exports